import {
  SANS_2,
  UI_BODY_SEMIBOLD_SM,
  UI_TAG,
  colors,
  colors2,
  useScreenWidth,
  icons,
  transition,
  UI_CAPTION,
  UI_BODY,
  Divider,
} from "oolib";
import React, { useRef, useState } from "react";

import { FilterInput } from "../../../../inputs/DynamicTagsInputs/FilterInput";
import {
  StyledSideFilterFlexVerticalGapShell,
  SideFilterHeaderStyled,
  SideFilterListWrapper,
  StyledSideFilterSectionPaddingShell,
  StyledAsideFilter,
  StyledAsideFilterContainer,
  StyledAsideFilterContentsWrapper,
  StyledFilterHeaderInnerWrapper,
} from "./styled";
import styled from "styled-components";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";
import { LightboxFilterHeader, AppliedFilters } from "./LightboxFilterHeader";
import { CohortsSection } from "../Cohorts/CohortsSection";

const { CaretUp } = icons;

const StyledIconRotator = styled.div`
  ${transition("transform")};
  transform: rotate(${({ open }) => (open ? "0" : "180deg")});
  display: flex;
  align-self: baseline;
`;

export const StyledCompWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  ${globalScrollbarStyling}
`;

// this is the second level section
const AccordionFilterGroupSection = ({
  children,
  title,
  subtitle,
  open: openFromParent = true,
}) => {
  const [open, setOpen] = useState(openFromParent);

  return (
    <div
      style={{
        border: `1px solid ${colors2.grey10}`,
        borderRadius: "6px",
      }}
    >
      <div
        style={{
          borderBottom: open ? `1px solid ${colors2.grey10}` : "none",
          padding: "0 0.4rem",
          cursor: "pointer",
        }}
        onClick={() => setOpen((prev) => !prev)}
        >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0.8rem",
              paddingBottom: subtitle ? "0rem" : "0.8rem" 
            }}
          >
            {title && <UI_BODY_SEMIBOLD_SM>{title}</UI_BODY_SEMIBOLD_SM>}
                <StyledIconRotator open={open}>
                <CaretUp size={16} style={{ marginTop: "0.2rem" }}/>
              </StyledIconRotator>
          </div>

          {subtitle && 
            <div style={{ padding: "0.8rem", paddingTop: "0.2rem", color: colors2.grey50 }}> <UI_CAPTION>{subtitle}</UI_CAPTION> </div>
          }
        
        </div>
      </div>
      <div style={{ padding: "0.4rem", display: open ? "block" : "none" }}>
        {children}
      </div>
    </div>
  );
};

export default function AsideFilter({
  onChange,
  selectedValues,
  activeFilters,
  setActiveFilters,
  filterConfig,
  presetActiveFilters,
  contentTypes,
  mobileHeader,
  isMobile,
  style,
  showClearAllButton = true,
  debug,
  savedFilterConfig,
  setSavedFilterConfig,
  setSavedActiveFilters,
  showFilterModuleV3 = false,
  addFilterAnchorEl,
  addFilterLightboxOpen,
  onAddFilterLightboxOpenChange,
  disableInlinePadding,
  skipLocalFilterSave = false,
  hideFilterModuleHeader = false,
  addFilterButtonText = "Add Filter",
  hideIntraFilterOperatorSelect = false,
  noAppliedValueChipsTruncation = false,
}) {
  const handleClearAllTags = () => setActiveFilters([]);
  
  const actionsAreaRef = useRef(null);
  const screenWidth = useScreenWidth();
  const isTab = screenWidth < 800 && screenWidth > 700; // exepction

  const generateFilters = (filterConfig) => {
    const genFilterInput = (f) => {
      const { filterId } = f;
      const isAnnoHierarchy = f?.source?.filterType === "annoHierarchyType";
      return (
        <FilterInput
          key={filterId}
          comp="AccordionMultiSelect"
          value={
            isAnnoHierarchy ? selectedValues : selectedValues[filterId] || []
          }
          onChange={(id, value, meta) => {
            onChange({
              id,
              value,
              meta,
            });
          }}
          filterConfig={f}
          activeFilters={activeFilters}
          presetActiveFilters={presetActiveFilters}
          contentTypes={contentTypes}
          debug={debug}
        />
      );
    };

    // Split into 3 categories
    const doubleNestedConfigs = filterConfig.filter(
      (f) => f.configs && f.configs.some((ff) => ff.configs)
    );

    const singleNestedConfigs = filterConfig.filter(
      (f) => f.configs && !f.configs.some((ff) => ff.configs)
    );

    const directConfigs = filterConfig.filter((f) => !f.configs);

    return (
      <div>
        {/* Double nested configs (f.configs with ff.configs) */}
        {doubleNestedConfigs.map((f, fI) => (
          <div
            key={f.sectionId}
            style={
              !showFilterModuleV3 && fI !== doubleNestedConfigs.length - 1
                ? { borderBottom: `1px solid ${colors2.grey10}` }
                : {}
            }
          >
            {showFilterModuleV3 && fI > 0 && <div data-lightbox-divider><Divider style={{ margin: "0.4rem 0" }} /></div>}
            {f.sectionTitle && (
              <div data-lightbox-header>
                <UI_TAG
                  style={{
                    padding: showFilterModuleV3  ?
                        `0.8rem 0.6rem 0 0.6rem` :
                        `1.4rem 1.4rem 0 1.4rem`,
                    color: colors2.grey50,
                  }}
                >
                  {f.sectionTitle}
                </UI_TAG>
              </div>
            )}
            <StyledSideFilterSectionPaddingShell style={{...style,
              padding: showFilterModuleV3 && `0`,
              margin: showFilterModuleV3 && `0.4rem 0 0`,
            }}>
              <StyledSideFilterFlexVerticalGapShell>
                {f.configs.map((ff, outerIndex) => {
                    // If no sectionTitle, render configs flat without accordion wrapper
                    if (!ff.sectionTitle) {
                      return (
                        <StyledSideFilterFlexVerticalGapShell key={`${ff.sectionId}-${outerIndex}`}>
                          {ff.configs.map((fff, innerIndex) => (
                            <div key={`${fff.filterId}-${outerIndex}-${innerIndex}`}>
                              {genFilterInput(fff)}
                            </div>
                          ))}
                        </StyledSideFilterFlexVerticalGapShell>
                      );
                    }
                    return(
                      <AccordionFilterGroupSection
                        key={`${ff.sectionId}-${outerIndex}`}
                        title={ff.sectionTitle}
                        subtitle={ff.sectionSubtitle}
                        >
                        <StyledSideFilterFlexVerticalGapShell>
                          {ff.configs.map((fff, innerIndex) =>
                              {
                                return <div key={`${fff.filterId}-${outerIndex}-${innerIndex}`}>
                                    {genFilterInput(fff)}
                                  </div>
                              }
                            )
                          }
                        </StyledSideFilterFlexVerticalGapShell>
                      </AccordionFilterGroupSection>
                    )
                  })
                }
              </StyledSideFilterFlexVerticalGapShell>
            </StyledSideFilterSectionPaddingShell>
          </div>
        ))}

        {/* Single nested configs (just f.configs) */}
        {singleNestedConfigs.map((f, fI) => (
          <div
            key={f.sectionId}
            style={
              !showFilterModuleV3 && fI !== singleNestedConfigs.length - 1
                ? { borderBottom: `1px solid ${colors2.grey10}` }
                : {}
            }
          >
            {showFilterModuleV3 && (fI > 0 || doubleNestedConfigs.length > 0) && <div data-lightbox-divider><Divider style={{ margin: "0.4rem 0" }} /></div>}
            {f.sectionTitle && (
              <div data-lightbox-header>
                <UI_TAG
                  style={{
                    padding: showFilterModuleV3  ?
                        `0.8rem 0.6rem 0 0.6rem` :
                        `1.4rem 1.4rem 0 1.4rem`,
                    color: colors2.grey50,
                  }}
                >
                  {f.sectionTitle}
                </UI_TAG>
              </div>
            )}
            <StyledSideFilterSectionPaddingShell style={{...style, padding: showFilterModuleV3 && `0` }}>
              <StyledSideFilterFlexVerticalGapShell>
                {f.configs.map((ff) => genFilterInput(ff))}
              </StyledSideFilterFlexVerticalGapShell>
            </StyledSideFilterSectionPaddingShell>
          </div>
        ))}

        {/* Direct configs (no nesting) */}
        {directConfigs.length > 0 && <>
          {showFilterModuleV3 && (doubleNestedConfigs.length > 0 || singleNestedConfigs.length > 0) && <div data-lightbox-divider><Divider style={{ margin: "0.4rem 0" }} /></div>}
          <StyledSideFilterSectionPaddingShell style={{...style, padding: showFilterModuleV3 && `0` }}>
            <StyledSideFilterFlexVerticalGapShell>
              {directConfigs.map((f) => genFilterInput(f))}
            </StyledSideFilterFlexVerticalGapShell>
          </StyledSideFilterSectionPaddingShell>
        </>}

        {showFilterModuleV3 && <CohortsSection setActiveFilters={setActiveFilters} />}
      </div>
    );
  };

  return (
    <StyledAsideFilter
      id="asideFilter"
    >
      <StyledAsideFilterContainer>
        <div
          ref={actionsAreaRef}
          style={{
            height: "max-content",
            width: "100%",
            position: "sticky",
            top: 0,
          }}
        >
          {mobileHeader && mobileHeader}
        </div>

        {(showFilterModuleV3 || addFilterAnchorEl) && (
          <LightboxFilterHeader
            filterConfig={filterConfig}
            savedFilterConfig={savedFilterConfig}
            setSavedFilterConfig={setSavedFilterConfig}
            setSavedActiveFilters={setSavedActiveFilters}
            generateFilters={generateFilters}
            activeFilters={activeFilters}
            setActiveFilters={setActiveFilters}
            anchorEl={addFilterAnchorEl}
            lightboxOpen={addFilterLightboxOpen}
            onLightboxOpenChange={onAddFilterLightboxOpenChange}
            hideFilterModuleHeader={hideFilterModuleHeader}
            addFilterButtonText={addFilterButtonText}
            hideIntraFilterOperatorSelect={hideIntraFilterOperatorSelect}
          />
        )}

        {/* ref is not available at this breakpoint as clear all filters  button moves to top */}
        <div
          id={"filtersWrapper"}
          style={{
            height: `calc(100% - ${
              actionsAreaRef.current?.getBoundingClientRect().height
            }px)`,
            overflow: "auto",
          }}
        >
          <div>
            {!isMobile && showClearAllButton && !showFilterModuleV3 && (
              <SideFilterHeaderStyled >
                <StyledFilterHeaderInnerWrapper>
                  <ButtonGhost
                    onClick={handleClearAllTags}
                    icon={"XCircle"}
                    iconSize={"S"}
                    disabled={activeFilters.length === 0}
                    iconColor={colors2.grey80}
                    style={{
                      color: colors2.grey80,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "start",
                      paddingLeft: "20px",
                      borderRadius: "0px",
                    }}
                  >
                    Clear All Filters
                  </ButtonGhost>
                </StyledFilterHeaderInnerWrapper>
              </SideFilterHeaderStyled>
            )}
            {!showFilterModuleV3 ? ( // old UI
              <StyledAsideFilterContentsWrapper
                id='asidefiltercontentswrapper'
              >
                <SideFilterListWrapper>
                  {generateFilters(filterConfig)}
                </SideFilterListWrapper>
              </StyledAsideFilterContentsWrapper>
            ) : (
              <AppliedFilters
                // When skipLocalFilterSave, we have no saved configs and want
                // no empty placeholder blocks generated — pass `[]` instead of
                // falling back to activeFilters (which would otherwise be
                // treated as saved configs and synthesize placeholders for
                // not-yet-active buckets like "Independent Tags").
                filterConfig={
                  skipLocalFilterSave
                    ? savedFilterConfig
                    : savedFilterConfig?.length > 0
                    ? savedFilterConfig
                    : activeFilters
                }
                activeFilters={activeFilters}
                setActiveFilters={setActiveFilters}
                setSavedFilterConfig={setSavedFilterConfig}
                onChange={onChange}
                allFilterConfig={filterConfig}
                contentTypes={contentTypes}
                disableInlinePadding={disableInlinePadding}
                hideIntraFilterOperatorSelect={hideIntraFilterOperatorSelect}
                noAppliedValueChipsTruncation={noAppliedValueChipsTruncation}
              />
            )}
          </div>
        </div>
      </StyledAsideFilterContainer>
    </StyledAsideFilter>
  );
}
